import React, { useEffect } from 'react';
import { X } from 'lucide-react';

export function ProgressBar({ value = 0, color, label, className = '' }) {
  const pct = Math.max(0, Math.min(100, Math.round(value)));
  return (
    <div className={`ss-progress ${className}`}>
      <div
        className="ss-progress__track"
        role="progressbar"
        aria-valuenow={pct}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={label}
      >
        <div className="ss-progress__fill" style={{ width: `${pct}%`, background: color }} />
      </div>
    </div>
  );
}

export function Loader({ label = 'Carregando...' }) {
  return (
    <div className="ss-loader" role="status">
      <span className="ss-loader__spin" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}

// Estado vazio no formato de "arquivo de código", como a capa do <Share/>.
export function EmptyState({ file = 'vazio.xml', title, description, action }) {
  return (
    <div className="ss-empty">
      <div className="ss-empty__code" aria-hidden="true">
        <div className="ss-empty__bar">
          <span className="ss-dot ss-dot--lime" />
          <span className="ss-dot ss-dot--white" />
          <span className="ss-dot ss-dot--ring" />
          <span className="ss-empty__file">{file}</span>
        </div>
        <code>
          <span className="c-com">{'<!-- nada por aqui ainda -->'}</span>
          <br />
          <span className="c-key">{'<Vazio'}</span>
          <br />
          <span className="c-key">{'  proximo'}</span>
          <span className="c-val">{'="é só começar"'}</span>
          <br />
          <span className="c-key">{'/>'}</span>
        </code>
      </div>
      <div className="ss-empty__text">
        <h3>{title}</h3>
        {description && <p>{description}</p>}
        {action && <div className="ss-empty__action">{action}</div>}
      </div>
    </div>
  );
}

export function Modal({ open, onClose, title, children, footer, width = 520 }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => e.key === 'Escape' && onClose?.();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="ss-modal" onClick={onClose}>
      <div
        className="ss-modal__panel"
        style={{ maxWidth: width }}
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="ss-modal__head">
          <h2>{title}</h2>
          <button type="button" className="ss-iconbtn" onClick={onClose} aria-label="Fechar">
            <X size={18} />
          </button>
        </div>
        <div className="ss-modal__body">{children}</div>
        {footer && <div className="ss-modal__foot">{footer}</div>}
      </div>
    </div>
  );
}

export function Field({ label, required, children, hint }) {
  return (
    <label className="ss-field">
      <span className="ss-field__label">
        {label}
        {required && <span className="ss-field__req"> *</span>}
      </span>
      {children}
      {hint && <span className="ss-field__hint">{hint}</span>}
    </label>
  );
}
